
import { Carousel } from 'react-responsive-carousel';
import { Typography } from '@mui/material';
import styles from './TextSlider.module.css';

const TextSlider = () => {
    return (
        <>

            <Carousel className={styles.TextSlider} autoPlay infiniteLoop axis="vertical" interval={3000} showStatus={false} showIndicators={false} centerMode showArrows={false} showThumbs={false}>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Deen</Typography>
                </div>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Islam</Typography>
                </div>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Ihsan</Typography>
                </div>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Quran</Typography>
                </div>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Sunnah</Typography>
                </div>
                <div className={styles.carouselImages}>
                    <Typography variant="h1" className="m-event">Fiqh</Typography>
                </div>
            </Carousel>
        </>
    );
};

export default TextSlider;